(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["after-dark-instagram-styles"] && !Shopify.designMode) return;
  try {
    (() => {
  // The feed's public, embedded post data retains Instagram's full caption.
  // Its default renderer strips hashtags and relocates them; preserve the
  // original text here without editing the source post or the app's data.
  const postKey = value => {
    try {
      const url = new URL(value, location.origin);
      if (!/(^|\.)instagram\.com$/.test(url.hostname)) return '';
      return url.pathname.match(/^\/(?:p|reel|tv)\/([^/]+)/)?.[1] || '';
    } catch (_) { return ''; }
  };
  function captions() {
    const result = new Map();
    const seen = new WeakSet();
    function visit(value, depth = 0) {
      if (!value || typeof value !== 'object' || seen.has(value) || depth > 12) return;
      seen.add(value);
      if (typeof value.caption === 'string' && typeof value.permalink === 'string') {
        const key = postKey(value.permalink);
        if (key) result.set(key, value.caption);
      }
      Object.values(value).forEach(child => visit(child, depth + 1));
    }
    visit(window.siInstaMF);
    visit(window.siInstaMFWidgets);
    return result;
  }
  function captionContent(text) {
    const fragment = document.createDocumentFragment();
    let cursor = 0;
    for (const match of text.matchAll(/#[\p{L}\p{N}_]+/gu)) {
      fragment.append(document.createTextNode(text.slice(cursor, match.index)));
      const link = document.createElement('a');
      link.textContent = match[0];
      link.href = 'https://www.instagram.com/explore/tags/' + encodeURIComponent(match[0].slice(1)) + '/';
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      fragment.append(link);
      cursor = match.index + match[0].length;
    }
    fragment.append(document.createTextNode(text.slice(cursor)));
    return fragment;
  }
  function restore() {
    const viewers = document.querySelectorAll('.si-instafeed-popup-container,.si-modal-scroll-wrapper .si-modal-content');
    if (!viewers.length) return;
    const originals = captions();
    viewers.forEach(viewer => {
      const key = Array.from(viewer.querySelectorAll('a[href]')).map(link => postKey(link.href)).find(Boolean);
      const holder = viewer.querySelector('.si-popup-post-body-wrapper');
      if (!holder) return;
      const text = originals.get(key);
      let output = holder.querySelector('.ad-ig-original-caption');
      if (typeof text !== 'string') {
        holder.classList.remove('ad-ig-caption-restored');
        output?.remove();
        return;
      }
      if (output?.dataset.post === key && output.textContent === text) return;
      if (!output) {
        output = document.createElement('div');
        output.className = 'ad-ig-original-caption';
        holder.append(output);
      }
      output.dataset.post = key;
      output.replaceChildren(captionContent(text));
      holder.classList.add('ad-ig-caption-restored');
    });
  }
  function init() {
    let pending = false;
    const schedule = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; restore(); });
    };
    new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['href']});
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["after-dark-random-collections"] && !Shopify.designMode) return;
  try {
    (() => {
  const storageKey = 'rpp-collection-discoveries-v1';
  const choose = (items, last, key) => {
    const fresh = items.filter(item => item[key] !== last);
    const pool = fresh.length ? fresh : items;
    return pool[Math.floor(Math.random() * pool.length)];
  };
  const shuffled = items => {
    const result = items.slice();
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  };
  function refresh(root) {
    const grid = root.querySelector('[data-discovery-grid]');
    const cards = Array.from(grid.querySelectorAll('[data-discovery-group]'));
    let previous = {};
    try { previous = JSON.parse(localStorage.getItem(storageKey) || '{}') || {}; } catch (_) {}
    const next = {collections: {}, images: { ...(previous.images || {}) }};
    for (const card of cards) {
      let pool;
      try { pool = JSON.parse(card.querySelector('[data-discovery-pool]').textContent); } catch (_) { continue; }
      if (!pool.length) continue;
      const group = card.dataset.discoveryGroup;
      const collection = choose(pool, previous.collections?.[group], 'handle');
      const artwork = choose(collection.images, previous.images?.[collection.handle], 'src');
      const link = card.querySelector('.ad-category__link');
      link.href = collection.url;
      card.querySelector('[data-discovery-title]').textContent = collection.title;
      const img = document.createElement('img');
      img.src = artwork.src;
      img.alt = artwork.alt;
      img.title = artwork.alt;
      img.width = artwork.width;
      img.height = artwork.height;
      img.loading = 'lazy';
      img.decoding = 'async';
      card.querySelector('.ad-category__image').replaceChildren(img);
      card.dataset.collection = collection.handle;
      next.collections[group] = collection.handle;
      next.images[collection.handle] = artwork.src;
    }
    let order = shuffled(cards);
    if (order.length > 1 && order.map(card => card.dataset.discoveryGroup).join('|') === previous.order) {
      order.push(order.shift());
    }
    order.forEach(card => grid.append(card));
    next.order = order.map(card => card.dataset.discoveryGroup).join('|');
    try { localStorage.setItem(storageKey, JSON.stringify(next)); } catch (_) {}
  }
  function init(scope) {
    scope.querySelectorAll('[data-random-collections]').forEach(refresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('pageshow', event => { if (event.persisted) init(document); });
})();
  } catch(e) { console.error(e); }
})();

})();
